// Class: starling.events.EnterFrameEvent

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_events_Event() {return require("./../../starling/events/Event");}

// Constructor

var EnterFrameEvent = function(type,passedTime,bubbles) {
	if(bubbles == null) {
		bubbles = false;
	}
	(starling_events_Event().default).call(this,type,bubbles,passedTime);
}

// Meta

EnterFrameEvent.__name__ = "starling.events.EnterFrameEvent";
EnterFrameEvent.__isInterface__ = false;
EnterFrameEvent.__super__ = (starling_events_Event().default);
EnterFrameEvent.prototype = $extend((starling_events_Event().default).prototype, {
	get_passedTime: function() {
		return this.data;
	}
});
EnterFrameEvent.prototype.__class__ = EnterFrameEvent.prototype.constructor = $hxClasses["starling.events.EnterFrameEvent"] = EnterFrameEvent;

// Init

Object.defineProperties(EnterFrameEvent.prototype,{ passedTime : { get : function () { return this.get_passedTime (); }}});

// Statics


EnterFrameEvent.ENTER_FRAME = "enterFrame"

// Export

exports.default = EnterFrameEvent;